<template>
  <!-- Hero section -->
  <div 
    class="relative min-h-[70vh] flex items-center justify-center bg-cover bg-center bg-fixed pt-20"
    :style="{ backgroundImage: `url('${image}')` }"
  >
    <!-- Overlay -->
    <div class="absolute inset-0 bg-gradient-to-br from-dark/70 via-primary/60 to-secondary/70"></div>
    
    <!-- Content -->
    <div class="relative z-10 container mx-auto px-4 text-center">
      <div class="max-w-4xl mx-auto">
        <h1 class="text-4xl md:text-5xl lg:text-6xl font-bold font-heading text-white leading-tight mb-6" data-sal="slide-up" data-sal-delay="200">
          {{ text }}
        </h1>
        <div v-if="subtitle" class="text-xl md:text-2xl text-white/90 font-medium" data-sal="slide-up" data-sal-delay="400">
          {{ subtitle }}
        </div>
      </div>
    </div>
  </div>
  <!-- end Hero section -->
</template>

<script>
  export default {
    name: 'HeroComponent',
    props: {
      image: {
        type: String,
        required: true
      },
      text: {
        type: String,
        required: true
      },
      subtitle: {
        type: String,
        default: null
      }
    }
  }
</script>